import AddCircleIcon from '@material-ui/icons/AddCircle'
import CloseIcon from '@material-ui/icons/Close'
import { Text } from 'shared/components/Text/Text'
import { lightGray2, midGray } from 'shared/theme/colors'
import styled from 'styled-components'

import { HandlerOf, truthy } from '../../helpers/typeHelper'
import { NotesAvailabelTag } from '../../models/note'
import { header4 } from '../../theme/typography'
import { FlexBox } from '../Base/FlexBox'
import { CheckboxDropdown } from '../Dropdown/CheckboxDropdown'
import { InlineSpinner } from '../Spinner'

interface NoteComposerProps {
  availableTags: NotesAvailabelTag[]
  addedTags: string[]
  setAddedTags: HandlerOf<string[]>
}

const MAX_TAGS = 2

export function NoteComposerAddTags({ availableTags, addedTags, setAddedTags }: NoteComposerProps) {
  function createTagsOptions({ label }: { label: string | undefined }) {
    const options = availableTags?.map((tag) => ({
      key: tag.label,
      label: tag.label,
      value: addedTags?.includes(tag.value) || false,
      onChange: () =>
        setAddedTags(
          addedTags?.includes(tag.value)
            ? addedTags.filter((t) => t !== tag.value)
            : addedTags.length < MAX_TAGS
            ? [...addedTags, tag.value]
            : addedTags
        ),
    }))

    return [label ? createTagLabelOption(label) : null, ...options].filter(truthy)
  }

  return (
    <TagsWrap>
      <TagsDropdown>
        <CheckboxDropdown
          label="Trailer type"
          placeholder="Trailer"
          options={createTagsOptions({
            label: availableTags?.length > MAX_TAGS ? `Select up to ${MAX_TAGS} tags` : undefined,
          })}
          maxHeight={400}
          width="250px"
        >
          <FlexBox alignItems="center" gap="5px" styles="height: 20px;">
            <AddTagIcon />
            {addedTags?.length === 0 ? (
              <Text color={lightGray2} variant="header4">
                Add tag
              </Text>
            ) : null}
          </FlexBox>
        </CheckboxDropdown>
      </TagsDropdown>

      <AddedTags>
        {addedTags.length ? (
          availableTags.length ? (
            addedTags.map((tag) => (
              <AddedTag key={tag}>
                <FlexBox alignItems="center" gap="5px">
                  {availableTags.find((t) => t.value === tag)?.label}
                  <RemoveTagIcon onClick={() => setAddedTags(addedTags.filter((t) => t !== tag))} />
                </FlexBox>
              </AddedTag>
            ))
          ) : (
            <InlineSpinner size="1em" mt={0.5} />
          )
        ) : null}
      </AddedTags>
    </TagsWrap>
  )
}

export function createTagLabelOption(label: string, isFirst = true) {
  return {
    disableCheckbox: true,
    value: false,
    onChange: () => null,
    label,
    labelElement: (
      <Text variant="header4" color={midGray} mb={0.7} mt={isFirst ? 0 : 1}>
        {label}
      </Text>
    ),
  }
}

const TagsWrap = styled.div`
  position: relative;
  min-height: 26px;
  margin: 5px 16px 10px;
`

const TagsDropdown = styled.div`
  position: absolute;
  left: 0;
  top: 0;
  height: 26px;
  display: flex;
  align-items: center;
`

const AddedTags = styled.div`
  display: inline-block;

  > :first-child {
    margin-left: 25px;
  }
`

const AddedTag = styled.div`
  ${header4};
  display: inline-block;
  height: 26px;
  padding: 3px 9px 2px;
  background: white;
  border-radius: 13px;
  margin-right: 5px;
`

const AddTagIcon = styled(AddCircleIcon)`
  font-size: 16px !important;
  color: ${lightGray2};
  margin-top: -2px;
`

const RemoveTagIcon = styled(CloseIcon)`
  font-size: 16px !important;
  color: ${lightGray2};
  margin-top: -2px;
`
